/* eslint-disable jsx-a11y/label-has-associated-control */
import {
  Avatar,
  Checkbox,
  ColorPicker,
  DatePicker,
  Empty,
  Input,
  Select,
  Upload,
} from 'antd';
import React, { useEffect, useState } from 'react';
// import InputMask from 'react-input-mask';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { regexInput } from 'utils/regex';
import { log } from 'utils';
import 'react-quill/dist/quill.snow.css';
import './AddWebPagesForm.css';

import DummyTemplateImage from 'assets/dummy-template/dummy-1.png';
import AddMenu from './AddMenu';
import {
  addWebMenus,
  fetchWebMenus,
  updateWebMenus,
} from 'state/actions/webMenus';
import { toastr } from 'react-redux-toastr';

const AddWebMenusForm = ({ error, onClose, menuData }) => {
  log(error);

  const [errors, setErrors] = useState(error);

  useEffect(() => {
    setErrors(error);
  }, [error]);

  const { loading, userData, categoriesList, poiList, information, category } =
    useSelector(
      (state) => ({
        loading: state.information.loading,
        userData: state.auth.userData,
        categoriesList: state.informationCategories.list,
        poiList: state.pois.list,
        information: state.information.information,
        category: state.informationCategories.category,
      }),
      shallowEqual
    );

  const uid = userData.id;

  const dispatch = useDispatch();
  const [tempSelectedCategory, setTempSelectedCategory] = useState();

  const [columnOne, setColumnOne] = useState('240px');
  const [columnTwo, setColumnTwo] = useState('100%');
  const [title, setTitle] = useState('');

  const [openAddSection, setOpenAddSection] = useState(true);
  const [selectedTitlePagesContainer, setSelectedTitlePagesContainer] =
    useState(false);

  useEffect(() => {
    if (information) {
      setTempSelectedCategory(information.categoryId);
    }
  }, [information]); // eslint-disable-line

  useEffect(() => {
    if (menuData) {
      setTitle(menuData.title);

      const urls = menuData.menuSettings?.items?.map((item) => item.url) || [];
      setSelectedItems(urls);
    }
  }, [menuData]);

  const [selectedItems, setSelectedItems] = useState([]);

  const menuItems = [
    {
      name: 'Homepage',
      url: 'homepage',
    },
    {
      name: 'About Us',
      url: 'about-us',
    },
    {
      name: 'Blog',
      url: 'blog',
    },
    {
      name: 'Contact Us',
      url: 'contact-us',
    },
    {
      name: 'Login',
      url: 'login',
    },
    {
      name: 'Register',
      url: 'register',
    },
    {
      name: 'Account',
      url: 'account',
    },
  ];

  const handleSelectAll = () => {
    if (selectedItems.length === menuItems.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(menuItems.map((item) => item.url));
    }
  };

  const handleItemToggle = (item) => {
    if (selectedItems.includes(item.url)) {
      setSelectedItems(selectedItems.filter((i) => i !== item.url));
    } else {
      setSelectedItems([...selectedItems, item.url]);
    }
  };

  const isAllSelected = selectedItems.length === menuItems.length;

  const { siteId } = useParams();

  const handleSubmitMenu = async (data) => {
    const itemsWithUrl = selectedItems.map((url) =>
      menuItems.find((item) => item.url === url)
    );

    const payload = {
      title: data.title,
      siteId: siteId,
      userId: userData.id,
      menuSettings: {
        items: itemsWithUrl,
        autoAddPages: data.menuSettings.autoAddPages,
        displayLocation: data.menuSettings.displayLocation,
      },
    };

    try {
      if (menuData?._id) {
        await dispatch(updateWebMenus(menuData._id, payload));
        toastr.success('Success', 'Web Menu updated successfully');
      } else {
        await dispatch(addWebMenus(payload));
        toastr.success('Success', 'Web Menu created successfully');
      }

      dispatch(fetchWebMenus());
      onClose();
    } catch (err) {
      console.log(err);
    }
  };

  const sectionTwo = () => {
    return (
      <div className="section-body">
        <div
          style={{
            width: columnOne,
            height: '100vh',
            background: '#F2F2F2',
          }}
          className="column-one"
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '240px',
            }}
          >
            <div
              className="title-container"
              onClick={() => setSelectedTitlePagesContainer(true)}
            >
              <span className="text">Pages</span>
            </div>
          </div>
          <div className="body-container">
            <div className="body-column">
              <div className="menu-container">
                <div className="select-all-section" onClick={handleSelectAll}>
                  <div className={`checkbox ${isAllSelected ? 'checked' : ''}`}>
                    {isAllSelected && <div className="checkmark"></div>}
                  </div>
                  <span className="menu-text">Select All</span>
                </div>

                <div className="menu-list">
                  <div className="menu-list">
                    {menuItems.map((item, index) => (
                      <div
                        key={index}
                        className="menu-item"
                        onClick={() => handleItemToggle(item)}
                      >
                        <div
                          className={`checkbox ${
                            selectedItems.includes(item.url) ? 'checked' : ''
                          }`}
                        >
                          {selectedItems.includes(item.url) && (
                            <div className="checkmark"></div>
                          )}
                        </div>
                        <span className="menu-text">{item.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="column-two body-section"
          style={{
            width: columnTwo,
          }}
        >
          <div
            style={{
              top: '0',
              right: '0',
              position: 'absolute',
            }}
            className="button-secondary"
            onClick={onClose}
          >
            <i className="feather-arrow-left" />
            Back
          </div>
          <AddMenu
            selectedItems={selectedItems}
            onSubmit={handleSubmitMenu}
            menuData={menuData}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="addWebPagesForm">{openAddSection && sectionTwo()}</div>
  );
};

export default AddWebMenusForm;
